export default __webpack_public_path__ + "static/media/tr.f56c263e.svg";